import { render, staticRenderFns } from "./ListaBens.vue?vue&type=template&id=c07b2c10&"
import script from "./ListaBens.vue?vue&type=script&lang=js&"
export * from "./ListaBens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports